import React from "react";
import Navbar from "@/components/marketing/Navbar";
import Footer from "@/components/marketing/Footer";

export default function MarketingShell({ children }) {
  return (
    <div className="min-h-screen pbh-page">
      <Navbar />
      {children}
      <Footer />
    </div>
  );
}
